<template>
  <div class="breadcrumb">
    <ul>
      <li
        v-for="(breadcrumb, idx) in breadcrumbs"
        :key="idx"
        @click="routeTo(idx)"
        :class="{'linked': !!breadcrumb.link}"
        class=""
      >{{ breadcrumb.name }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    breadcrumbs: { type: Array, required: true }
  },
  methods: {
    routeTo(idx) {
      if (this.breadcrumbs[idx].link)
        this.$router.push(this.breadcrumbs[idx].link);
    },
  },
};
</script>

<style scoped>
ul {
  display: flex;
  justify-content: left;
  list-style-type: none;
  padding-left: 0;
}
ul > li {
  display: flex;
  float: left;
  width: auto;
  color: black;
  font-weight: bold;
  font-size: 1.1em;
  cursor: default;
  align-items: center;
}
ul > li:not(:last-child)::after {
  content: ">";
  float: right;
  font-size: 1.1em;
  margin: 0 0.5em;
  /* color: grey; */
  color: black;
  cursor: default;
}
.linked {
  cursor: pointer;
  font-size: 1.1em;
  font-weight: normal;
  /* color: grey; */
  color: black;
}
</style>